/* eslint-disable camelcase */
export const GET_NDCs_LIST_SEARCH_BY_NAME_OR_NDCs =
  'GET_NDCs_LIST_SEARCH_BY_NAME_OR_NDCs';
export const GET_NDCs_LIST_MODAL_SEARCH_BY_NAME_OR_NDCs =
  'GET_NDCs_LIST_MODAL_SEARCH_BY_NAME_OR_NDCs';
export const GET_EXCLUDED_NDC_SEARCH = 'GET_EXCLUDED_NDC_SEARCH';
export const GET_COMMON_DROPDOWN_DATA = 'GET_COMMON_DROPDOWN_DATA';
export const GET_ALL_MANUFATURERE_LIST = 'GET_ALL_MANUFATURERE_LIST';
export const GET_ALL_LABELER_LIST = 'GET_ALL_LABELER_LIST';
export const GET_NDCS_LIST_BY_MANUFACTURERS = 'GET_NDCS_LIST_BY_MANUFACTURERS';
export const SAVE_EXCLUDED_NDC = 'SAVE_EXCLUDED_NDC';
export const VIEW_HISTORY = 'VIEW_HISTORY';
export const SEARCH_TABLE_ACTION = 'SEARCH_TABLE_ACTION';
export const SEARCH_TABLE_NDCS_LIST = 'SEARCH_TABLE_NDCS_LIST';
export const MODAL_SEARCH_TABLE_NDCS_LIST = 'MODAL_SEARCH_TABLE_NDCS_LIST';
export const EXCLUDED_NDCS_ERROR_MSG = 'EXCLUDED_NDCS_ERROR_MSG';
export const EXCLUDED_NDCS_EXTRA_STATE = 'EXCLUDED_NDCS_EXTRA_STATE';
export const CLEAR_EXCLUDED_NDCS_REDUX_DATA = 'CLEAR_EXCLUDED_NDCS_REDUX_DATA';
export const FILTER_AND_SORT_FOR_EXCLUDED_NDC =
  'FILTER_AND_SORT_FOR_EXCLUDED_NDC';
export const UPDATE_NDCS_LIST_VALUE_UNDER_AG_GRID =
  'UPDATE_NDCS_LIST_VALUE_UNDER_AG_GRID';
export const EXISTING_NDC_LIST = 'EXISTING_NDC_LIST';
